import { MineDefs } from './defs.js';

/**
 * Mounts the scene's gradients once for the whole document.
 *
 * SVG paint references resolve document-wide, so declaring them here lets the
 * mine, the miner previews in the bottom sheet and the rows on the Miners page
 * all share one set — no duplicated ids, no duplicated paint cost.
 */
export function SceneDefs() {
  return (
    <svg
      width="0"
      height="0"
      aria-hidden="true"
      focusable="false"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
    >
      <MineDefs />
    </svg>
  );
}
